var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingSizeAscending = function SvgDataSortingSizeAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v2h3V3H3Zm14 0v14h-3l4 4 4-4h-3V3h-2ZM3 7v2h5V7H3Zm0 4v2h7v-2H3Zm0 4v2h9v-2H3Zm0 4v2h11v-2H3Z"
  })));
};
export default SvgDataSortingSizeAscending;